import { useSelector } from 'react-redux'
import { RootState } from '../reducers'

export const useRole = () => {
  const role = useSelector<RootState, string | null>(s => s.auth.role)
  return { role, isSuper: role === 'super' }
}
